// PC-4c.2: client mirror of the server's reply-window helper
// (apps/server/src/lib/bridges/core.ts isWithinSessionWindow). Presentation only;
// the server's outbound worker is the authoritative enforcement.
const SESSION_WINDOW_MS = 24 * 60 * 60 * 1000;

export function isReplyWindowOpen(
  lastInboundAt: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!lastInboundAt) return false;
  return now.getTime() - new Date(lastInboundAt).getTime() < SESSION_WINDOW_MS;
}

export function replyWindowClosedLabel(): string {
  return "Reply window closed - waiting for the customer's next message.";
}
